/**
 * Filipino (fil) — translation file
 * All keys use flat namespace.key format
 * Cultural note: Filipino gaming culture naturally mixes English gaming terms.
 * Proper nouns, technical terms (ISD, USDC), and common gaming
 * terminology are kept in English where natural. ISD is the spend-only currency; Gold is mined.
 */
export const fil: Record<string, string> = {
  // ── Menu Scenes ──────────────────────────────────────────
  'menu.play_game': 'MAGLARO',
  'menu.version': 'v0.1.0 - PHASER MIGRATION',
  'menu.back_to_menu': 'BUMALIK SA MENU',

  // ── Options ──────────────────────────────────────────────
  'options.title': 'MGA OPSYON',
  'options.graphics': 'GRAPHICS',
  'options.audio': 'AUDIO',
  'options.gameplay': 'GAMEPLAY',
  'options.language': 'WIKA',
  'options.resolution': 'Resolution:',
  'options.quality': 'Kalidad:',
  'options.fullscreen': 'Fullscreen',
  'options.autosave': 'Auto-save',
  'options.show_tooltips': 'Ipakita ang Tooltips',
  'options.master_volume': 'Master Volume',
  'options.music_volume': 'Music Volume',
  'options.sfx_volume': 'SFX Volume',
  'options.difficulty': 'Difficulty:',
  'options.select_language': 'Pumili ng Wika',

  // ── Login ────────────────────────────────────────────────
  'login.brand_crimson': 'CRIMSON',
  'login.brand_mandate': 'MANDATE',
  'login.tagline': 'Mine\u2022Trade\u2022Conquer\u2022Earn USDC',
  'login.version': 'CRIMSON MANDATE v0.1.0',
  'login.enter_email': 'ILAGAY ANG EMAIL',
  'login.email_placeholder': 'kumander@fleet.com',
  'login.enter_password': 'ILAGAY ANG PASSWORD',
  'login.password_placeholder': '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022',
  'login.remember_me': 'TANDAAN AKO',
  'login.conquer_galaxy': 'SAKUPIN ANG GALAXY',
  'login.connecting': 'KUMOKONEKTA...',
  'login.forgot_password': 'NAKALIMUTAN ANG PASSWORD?',
  'login.create_account': 'GUMAWA NG ACCOUNT >',
  'login.password_reset_soon': 'Malapit nang magkaroon ng password reset',
  'login.shop_banner': 'Kailangan mo ng account para makabili ng barko. Mag-login o gumawa ng account sa ibaba.',
  'login.enter_email_password': 'Ilagay ang email at password',
  'login.server_unavailable': 'Hindi available ang server. Subukan ulit mamaya.',
  'login.login_failed': 'Hindi makapag-login',
  'login.connection_failed': 'Hindi makakonekta',
  'login.unknown_error': 'Hindi kilalang error',

  // ── Register ─────────────────────────────────────────────
  'register.commander_name': 'PANGALAN NG KUMANDER',
  'register.username_placeholder': 'CaptainNova',
  'register.email_address': 'EMAIL ADDRESS',
  'register.password': 'PASSWORD',
  'register.confirm_password': 'KUMPIRMAHIN ANG PASSWORD',
  'register.create_commander': 'GUMAWA NG KUMANDER',
  'register.creating': 'GINAGAWA...',
  'register.back_to_login': '< BUMALIK SA LOGIN',
  'register.strength_length': '\u2298 8+ na karakter',
  'register.strength_number': '\u2298 Numero',
  'register.strength_symbol': '\u2298 Simbolo',
  'register.passwords_match': '\u2713 Magkatugma ang password',
  'register.passwords_no_match': '\u2717 Hindi magkatugma ang password',
  'register.fill_all_fields': 'Punan lahat ng fields',
  'register.name_too_short': 'Ang pangalan ng kumander ay dapat 3+ na karakter',
  'register.password_too_short': 'Ang password ay dapat 8+ na karakter',
  'register.passwords_mismatch': 'Hindi magkatugma ang mga password',
  'register.account_created_login': 'Nagawa na ang account! Naglo-login...',
  'register.account_created_connect': 'Nagawa na ang account! Kumokonekta...',
  'register.connection_failed': 'Nagawa ang account, pero nag-timeout ang koneksyon sa laro. Subukang i-refresh o mag-login.',
  'register.registration_failed': 'Hindi makapag-register',

  // ── HUD Top Bar ──────────────────────────────────────────
  'hud.logo': 'CRIMSON\nMANDATE',
  'hud.menu': '\u2630 Menu',

  // ── Nav Buttons ──────────────────────────────────────────
  'nav.wreck': 'Wreck',
  'nav.insure': 'Insure',
  'nav.trade': 'Trade',
  'nav.ore': 'Ore',
  'nav.crew': 'Crew',
  'nav.parts': 'Parts',
  'nav.shop': 'Shop',
  'nav.buy_isd': 'Bili ISD',
  'nav.station': 'Station',
  'nav.center': 'Center',
  'nav.follow': 'Follow',
  'nav.research': 'Research',
  'nav.tech': 'Tech',
  'nav.alliance_hq': 'Alyansa HQ',
  'nav.refund': 'Buy-Back',
  'nav.withdraw': 'Withdraw',

  // ── Disconnect Overlay ───────────────────────────────────
  'disconnect.title': 'NAWALAN NG KONEKSYON',
  'disconnect.idle': 'Na-disconnect dahil sa hindi pag-galaw.',
  'disconnect.reconnecting': 'Kumokonekta ulit... ({attempt}/{max})',
  'disconnect.failed': 'Hindi makakonekta ulit.',
  'disconnect.reconnect': 'Kumonekta Ulit',

  // ── Dialog Titles ────────────────────────────────────────
  'dialog.menu': 'MENU',
  'dialog.ship_store': 'TINDAHAN NG BARKO',
  'dialog.components': 'MGA COMPONENT',
  'dialog.ore_inventory': 'MGA MINERAL',
  'dialog.wreckage': 'MGA WRECKAGE',
  'dialog.insurance': 'INSURANCE',
  'dialog.stations': 'MGA STATION',
  'dialog.crew_quarters': 'CREW QUARTERS',
  'dialog.trade_hub': 'TRADE HUB',
  'dialog.browse_alliances': 'HANAPIN ANG ALYANSA',
  'dialog.alliance_hq': 'ALYANSA HQ',
  'dialog.commander_profile': 'PROFILE NG KUMANDER',
  'dialog.refund': 'BUY-BACK',
  'dialog.relic_inventory': 'MGA RELIC',
  'dialog.tech_database': 'TECHNOLOGY DATABASE',
  'dialog.buy_isd': 'BUMILI NG $ISD',
  'dialog.ship_modification': 'SHIP MODIFICATION',
  'dialog.while_away': 'HABANG WALA KA',
  'dialog.research_board': 'PUBLIC RESEARCH BOARD',
  'dialog.component_enhancement': 'COMPONENT ENHANCEMENT',
  'dialog.alliance': 'ALYANSA',
  'dialog.create_alliance': 'GUMAWA NG ALYANSA',
  'dialog.alliance_management': 'Pamamahala ng Alyansa',
  'dialog.direct_messages': 'MGA MENSAHE',
  'dialog.battle_report': 'BATTLE REPORT',
  'dialog.build_ship': 'GAWA NG BARKO \u2014 {planetName}',
  'dialog.pirate_faction': 'PIRATE FACTION',
  'dialog.player_profile': 'PROFILE NG PLAYER',
  'dialog.ship_details': 'DETALYE NG BARKO',
  'dialog.component_loadout': 'COMPONENT LOADOUT',
  'dialog.repair_component': 'REPAIR COMPONENT',

  // ── Resource Display ─────────────────────────────────────
  'resource.title': 'Mga Resources',
  'resource.credits': 'ISD',
  'resource.minerals': 'Minerals',
  'resource.rare_metals': 'Rare Metals',
  'resource.tech_data': 'Tech Data',
  'resource.salvage': 'Salvage',
  'resource.exotic_matter': 'Exotic Matter',

  // ── Left Sidebar ─────────────────────────────────────────
  'sidebar.empire_status': 'Kalagayan ng Imperyo',
  'sidebar.stations': 'MGA STATION',
  'sidebar.ships': 'MGA BARKO',
  'sidebar.explored': 'NA-EXPLORE',
  'sidebar.explored_hexes': '{count} Hexes',
  'sidebar.credit': 'CREDIT',
  'sidebar.fleet': 'FLEET',
  'sidebar.missions': 'MGA MISYON',
  'sidebar.no_ships': 'Walang naka-deploy na barko',
  'sidebar.no_stations': 'Walang naka-deploy na station',
  'sidebar.planet': 'Planeta',
  'sidebar.station_label': 'Station',
  'sidebar.docked': 'Naka-dock',
  'sidebar.docked_at': '\u2693 {location}',
  'sidebar.moving': 'Gumagalaw ({turns}t)',
  'sidebar.hp_percent': 'HP {pct}%',
  'sidebar.cargo': 'CARGO {used}/{cap}',
  'sidebar.no_missions': 'Walang misyon\nna available',
  'sidebar.coming_soon': 'Malapit na',

  // ── Right Panel (Alliance) ───────────────────────────────
  'alliance.title': 'Alyansa',
  'alliance.members': '{count} members',
  'alliance.online': '{count} online',
  'alliance.view': 'TINGNAN',
  'alliance.message': 'MENSAHE',
  'alliance.create': 'GUMAWA',
  'alliance.browse': 'HANAPIN',

  // ── Chat Panel ───────────────────────────────────────────
  'chat.tab_chat': 'CHAT',
  'chat.tab_log': 'LOG',
  'chat.channel_alliance': 'ALYANSA',
  'chat.channel_global': 'GLOBAL',
  'chat.placeholder': 'Mag-type ng mensahe...',
  'chat.me': 'Ako',
  'chat.title': 'Komunikasyon',
  'chat.no_messages': 'Wala pang mensahe.\nMag-type sa ibaba para magsimula ng chat.',
  'chat.log_initialized': 'Na-initialize na ang activity log',

  // ── Command Dock ─────────────────────────────────────────
  // Action buttons
  'action.move': 'GALAW',
  'action.attack': 'ENGAGE',
  'action.dock': 'DOCK',
  'action.undock': 'UNDOCK',
  'action.mine': 'MINE',
  'action.stop': 'STOP',
  'action.repair': 'REPAIR',
  'action.modify': 'MODIFY',
  'action.goto': 'GOTO',
  'action.return': 'RETURN',
  'action.cancel': 'CANCEL',
  'action.rename': 'Palitan Pangalan',
  'action.paint': 'Paint',
  'action.sensor_boost': 'Sensor Boost',
  'action.warp': 'Warp',
  'action.beacon': 'Beacon',
  'action.deliver': 'Priority Deliver',
  'action.pick_color': 'Pumili ng Kulay',
  'action.select_ship_attack': 'Pumili ng Ship na Aatakin',
  'action.select_ship_move': 'Pumili ng Ship na Ililipat',

  // Action tooltips
  'tooltip.move': 'Ilipat ang barko mo sa isang hex',
  'tooltip.attack': 'Atakihin ang kalaban na barko',
  'tooltip.dock': 'Mag-dock sa planeta o station',
  'tooltip.undock': 'Umalis sa kasalukuyang daungan',
  'tooltip.mine': 'Mag-mine ng minerals mula sa asteroid',
  'tooltip.stop_mine': 'Itigil ang pag-mine',
  'tooltip.repair': 'I-repair ang hull gamit ang cargo minerals',
  'tooltip.repair_full': 'Puno na ang buhay ng unit',
  'tooltip.modify': 'I-modify ang ship components sa shipyard',
  'tooltip.modify_dock': 'Mag-dock sa station para mag-modify ng barko',
  'tooltip.goto': 'Pumunta sa specific na coordinates',
  'tooltip.return_to_base': 'Bumalik sa pinakamalapit na friendly station at auto-dock',
  'tooltip.mine_minerals': 'Mag-mine ng minerals...',
  'tooltip.mine_stellar': 'Mag-mine ng Gold...',
  'tooltip.mine_move_adjacent': 'Lumapit sa asteroid para mag-mine',
  'tooltip.dock_no_target': 'Lumapit sa 1 hex ng planeta o station para mag-dock',
  'tooltip.dock_no_range': 'Walang planeta o station sa malapit para daungan',
  'tooltip.dock_disabled': 'Hindi makakapag-dock dito',
  'tooltip.undock_move': 'Mag-undock para makalipat',
  'tooltip.repair_hull': 'Ayusin ang Hull',
  'tooltip.full_health': 'Puno ang Buhay',
  'tooltip.modify_components': 'Baguhin ang Components',
  'tooltip.dock_to_modify': 'Mag-dock muna para mabago',
  'tooltip.speed': 'Bilis',
  'tooltip.attack_stat': 'Atake',
  'tooltip.defense': 'Depensa',
  'tooltip.range': 'Saklaw',
  'tooltip.hull_integrity': 'Kalagayan ng Hull',
  'tooltip.shields_desc': 'Paglalarawan ng Shield',
  'tooltip.sensor_sweep': 'Sensor Sweep',
  'tooltip.evasive_maneuvers': 'Evasive Maneuvers',
  'tooltip.afterburner': 'Afterburner',
  'tooltip.missile_barrage': 'Missile Barrage',
  'tooltip.broadside': 'Broadside',
  'tooltip.shield_overcharge': 'Shield Overcharge',
  'tooltip.emergency_jump': 'Emergency Jump',
  'tooltip.richness': 'Yaman',
  'tooltip.remaining_ore': 'Natitirang Ore',
  'tooltip.rarity': 'Rarity',
  'tooltip.asteroid_stellar': 'May crypto',
  'tooltip.asteroid_no_stellar': 'Walang crypto',
  'tooltip.planet_structural': 'Kalagayan ng Planeta',
  'tooltip.station_structural': 'Kalagayan ng Station',
  'tooltip.mineral_storage': 'Mineral Storage',
  'tooltip.docked_planet': 'Naka-dock sa Planeta',
  'tooltip.docked_station': 'Naka-dock sa Station',
  'tooltip.fee_earth': 'Bayad sa Earth',
  'tooltip.fee_station': 'Bayad sa Station',
  'tooltip.planet_status': 'Status ng Planeta',
  'tooltip.station_status': 'Status ng Station',

  // Stat labels
  'stat.health': 'BUHAY',
  'stat.shields': 'SHIELDS',
  'stat.speed': 'BILIS',
  'stat.attack': 'ATTACK',
  'stat.defense': 'DEFENSE',
  'stat.range': 'RANGE',
  'stat.storage': 'STORAGE',
  'stat.docked': 'Naka-dock',
  'stat.fee': 'Bayad',
  'stat.status': 'Status',
  'stat.active': 'Aktibo',
  'storage.label': 'Storage',

  // Stat tooltips
  'stat_tip.health': 'Kasalukuyang hull integrity',
  'stat_tip.shields': 'Lakas ng energy shield',
  'stat_tip.movement': 'Hex na nalalakad bawat turn',
  'stat_tip.attack': 'Damage ng armas',
  'stat_tip.defense': 'Damage mitigation',
  'stat_tip.range': 'Pinakamalayong range ng armas',

  // Abilities
  'ability.scan': 'SCAN',
  'ability.evade': 'EVADE',
  'ability.boost': 'BOOST',
  'ability.volley': 'VOLLEY',
  'ability.broad': 'BROAD',
  'ability.shield': 'SHIELD',
  'ability.jump': 'JUMP',
  'ability.none': 'Walang abilities',

  'ability_tip.scan': 'I-scan ang paligid',
  'ability_tip.evade': 'Pumasok sa evasive flight mode',
  'ability_tip.boost': 'I-boost ang bilis ng engine',
  'ability_tip.volley': 'Iputok lahat ng armas sabay-sabay',
  'ability_tip.broad': 'Iputok ang broadside cannons',
  'ability_tip.shield': 'I-overcharge ang shield generator',
  'ability_tip.jump': 'Simulan ang warp jump',

  // Tabs (ship)
  'tab.actions': 'MGA AKSYON',
  'tab.abilities': 'MGA ABILITIES',
  'tab.cargo': 'CARGO {used}/{cap}',
  'tab.crew': 'CREW',
  'tab.upgrades': 'MGA UPGRADE',

  // Tabs (planet)
  'tab.storage': 'STORAGE',
  'tab.stellar': 'GOLD',
  'tab.build': 'GAWA',

  // Tabs (station)
  'tab.manage': 'PAMAHALAAN',

  // Cargo
  'cargo.full_tooltip': 'Puno na ang cargo! Mag-dock sa planeta o station para mag-deposit.',
  'cargo.loading': 'Nilo-load ang cargo...',
  'cargo.empty': 'Walang laman ang cargo hold',

  // Storage
  'storage.loading': 'Nilo-load ang inventory...',
  'storage.empty': 'Walang naka-store na minerals',
  'storage.stellar_stored': 'Naka-store na Gold',
  'storage.buy_ship': 'BUMILI NG BARKO',
  'storage.buy_parts': 'BUMILI NG PARTS',
  'storage.buy_crew': 'BUMILI NG CREW',

  // Asteroid
  'asteroid.richness': 'YAMAN',
  'asteroid.rarity': 'RARITY',
  'asteroid.stellar': 'GOLD',
  'asteroid.composition': 'KOMPOSISYON',
  'asteroid.remaining_ore': 'Natitirang Ore',
  'asteroid.stellar_label': 'Crypto',
  'asteroid.legendary': 'Legendary',
  'asteroid.very_rich': 'Napakayaman',
  'asteroid.rich': 'Mayaman',
  'asteroid.moderate': 'Katamtaman',
  'asteroid.poor': 'Mahina',
  'asteroid.no_mineral_data': 'Walang mineral data',
  'asteroid.suffix': ' Asteroid',

  // Richness tiers
  'richness.legendary': 'Legendary',
  'richness.very_rich': 'Napakayaman',
  'richness.rich': 'Mayaman',
  'richness.moderate': 'Katamtaman',
  'richness.poor': 'Mahina',

  // Rarity tiers
  'rarity.legendary': 'Legendary',
  'rarity.epic': 'Epic',
  'rarity.rare': 'Rare',
  'rarity.uncommon': 'Uncommon',
  'rarity.common': 'Common',

  // Asteroid richness tooltips
  'asteroid_tip.richness': 'Kalidad ng mineral concentration',
  'asteroid_tip.rarity': 'Gaano kabihira ang asteroid na ito',
  'asteroid_tip.stellar': 'Gold reward kapag na-tow sa Earth',

  // Asteroid variant names
  'asteroid_variant.gold': 'Gold',
  'asteroid_variant.platinum': 'Platinum',
  'asteroid_variant.dark_matter': 'Dark Matter',

  // Minerals
  'mineral.iron': 'Iron',
  'mineral.copper': 'Copper',
  'mineral.titanium': 'Titanium',
  'mineral.platinum': 'Platinum',
  'mineral.rhodium': 'Rhodium',
  'mineral.palladium': 'Palladium',
  'mineral.iridium': 'Iridium',
  'mineral.dark_matter': 'Dark Matter',
  'mineral.rare': 'Rare',
  'mineral.common': 'Common',
  'mineral.epic': 'Epic',
  'mineral.uncommon': 'Uncommon',

  // Wreck
  'wreck.suffix': ' Wreck',
  'wreck.time_left': 'NATITIRANG ORAS',
  'wreck.type': 'TIPO',
  'wreck.tow': 'TOW',
  'wreck.repair_label': 'REPAIR',
  'wreck.your_wreck': 'WRECK MO',
  'wreck.manage': 'PAMAHALAAN',
  'wreck.being_towed': 'TINI-TOW',
  'wreck.being_repaired': 'NIRE-REPAIR',
  'wreck.claimed': 'NA-CLAIM',
  'wreck.claim': 'I-CLAIM',
  'wreck.repair': 'Ayusin',

  // Enemy / Unit
  'unit.you': '(IKAW)',
  'unit.enemy': 'KALABAN',
  'unit.loading': 'Nilo-load...',
  'unit.no_ships': 'Wala kang barko',
  'unit.select_attack': 'PUMILI NG BARKO NA AATAKIHIN',
  'unit.select_move': 'PUMILI NG BARKO NA ILILIPAT',

  'enemy.badge': 'KALABAN',

  // Enemy actions
  'enemy.player': 'PLAYER',
  'enemy.ship': 'BARKO',
  'enemy.message': 'MENSAHE',
  'enemy.move_to': 'PUMUNTA SA',

  // Planet
  'planet.home': '\u2605 TAHANAN',
  'planet.neutral': 'NEUTRAL',
  'planet.your_planet': 'PLANETA MO',
  'planet.docked': 'NAKA-DOCK',
  'planet.fee': 'BAYAD',
  'planet.status': 'ESTADO',
  'planet.active': 'AKTIBO',
  'planet.nothing_producing': 'Walang ginagawa',
  'planet.no_production': 'Walang produksyon',
  'planet.done': 'TAPOS',
  'planet.in_progress': 'GINAGAWA',
  'planet.more_queued': '+{n} pa sa pila',
  'planet.produce_ship': 'GUMAWA NG BARKO',
  'planet.produce_ship_tooltip': 'Gumawa ng bagong barko sa planetang ito',

  // Station
  'station.waypoint': 'Waypoint',
  'station.depot': 'Depot',
  'station.fortress': 'Fortress',
  'station.capital': 'Capital',
  'station.your_station': 'STATION MO',
  'station.stored_asteroids': 'Naka-store na Asteroids',
  'station.docking_fee': 'Docking Fee',
  'station.manage_station': 'PAMAHALAAN ANG STATION',
  'station.manage_tooltip': 'Buksan ang station management panel',
  'station.produce_tooltip': 'Gumawa ng bagong barko sa station na ito',
  'station.enemy': 'KALABAN',
  'station.nothing_producing': 'Walang ginagawa',
  'station.no_production': 'Walang produksyon',
  'station.done': 'TAPOS',
  'station.in_progress': 'GINAGAWA',
  'station.produce_ship': 'GUMAWA NG SHIP',

  // Upgrades / Burn sinks
  'upgrade.rename': 'Palitan Pangalan',
  'upgrade.rename_prompt': 'Ilagay ang bagong pangalan ng barko (max 20 karakter):',
  'upgrade.rename_tooltip': 'Bigyan ng unique na pangalan ang barko mo (100 ISD)',
  'upgrade.paint': 'Pintura',
  'upgrade.paint_tooltip': 'Palitan ang kulay ng barko (100 ISD)',
  'upgrade.sensor': 'Sensor+',
  'upgrade.sensor_tooltip': 'Palawakin ang sensor range ng 1 hex (500 ISD)',
  'upgrade.warp': 'Warp',
  'upgrade.warp_soon': 'Warp jump: malapit nang magkaroon ng hex selection',
  'upgrade.warp_tooltip': 'I-unlock ang warp jump ability (2000 ISD)',
  'upgrade.beacon': 'Beacon',
  'upgrade.beacon_no_alliance': 'Dapat member ka ng alyansa para maglagay ng beacon',
  'upgrade.beacon_tooltip': 'Maglagay ng fleet beacon sa lokasyon mo (200 ISD)',
  'upgrade.deliver': 'Priority',
  'upgrade.deliver_tooltip': 'Markahan bilang priority delivery para sa towing (300 ISD)',
  'upgrade.pick_color': 'PUMILI NG KULAY',

  // Paint colors
  'color.red': 'Pula',
  'color.green': 'Berde',
  'color.blue': 'Asul',
  'color.yellow': 'Dilaw',
  'color.pink': 'Pink',
  'color.cyan': 'Cyan',
  'color.orange': 'Orange',
  'color.white': 'Puti',

  // GOTO popup
  'goto.q': 'Q',
  'goto.r': 'R',
  'goto.go': 'GO',

  // Ship types
  'ship.scout': 'Scout',
  'ship.fighter': 'Fighter',
  'ship.destroyer': 'Destroyer',
  'ship.bomber': 'Bomber',
  'ship.trade_ship': 'Trade Ship',
  'ship.cruiser': 'Cruiser',
  'ship.carrier': 'Carrier',
  'ship.battleship': 'Battleship',
  'ship.dreadnought': 'Dreadnought',
  'ship.titan': 'Titan',
  'ship.space_tug': 'Space Tug',
  'ship.alien_leviathan': 'Alien Leviathan',

  // Ship roles
  'role.recon': 'Recon',
  'role.light_combat': 'Light Combat',
  'role.strike': 'Strike',
  'role.heavy_strike': 'Heavy Strike',
  'role.logistics': 'Logistics',
  'role.heavy_combat': 'Heavy Combat',
  'role.fleet_support': 'Fleet Support',
  'role.assault': 'Assault',
  'role.capital': 'Capital',
  'role.flagship': 'Flagship',

  // Ship store
  'store.buy_ship': 'BUMILI NG SHIP',
  'store.buy_parts': 'BUMILI NG PARTS',
  'store.buy_crew': 'KUMUHA NG CREW',
  'store.credits': 'ISD: {n}',
  'store.loading_prices': 'Nilo-load ang mga presyo ng barko...',
  'store.load_failed': 'Hindi ma-load ang mga presyo. Subukan ulit mamaya.',

  // Component categories
  'comp.all': 'LAHAT',
  'comp.weap': 'ARMAS',
  'comp.eng': 'ENG',
  'comp.shld': 'SHLD',
  'comp.armr': 'ARMR',
  'comp.snsr': 'SNSR',
  'comp.rctr': 'RCTR',
  'comp.spec': 'SPEC',

  // Component tiers
  'tier.mk1': 'Mk I',
  'tier.mk2': 'Mk II',
  'tier.mk3': 'Mk III',
  'tier.mk4': 'Mk IV',
  'tier.proto': 'Proto',
  'tier.basic': 'Basic',
  'tier.improved': 'Improved',
  'tier.advanced': 'Advanced',
  'tier.elite': 'Elite',
  'tier.experimental': 'Experimental',

  // Component stats
  'comp_stat.hull_hp': 'Hull HP',
  'comp_stat.shields': 'Shields',
  'comp_stat.armor': 'Armor',
  'comp_stat.speed': 'Bilis',
  'comp_stat.evasion': 'Evasion',
  'comp_stat.sensor_range': 'Sensor Range',
  'comp_stat.accuracy': 'Accuracy',
  'comp_stat.attack': 'Attack',
  'comp_stat.defense': 'Defense',
  'comp_stat.power_output': 'Power Output',
  'comp_stat.cooldown_reduc': 'Cooldown Reduc.',
  'comp_stat.shield_regen': 'Shield Regen',
  'comp_stat.damage': 'Damage',
  'comp_stat.fire_rate': 'Fire Rate',

  // Hamburger menu
  'hamburger.audio': 'AUDIO',
  'hamburger.master': 'Master',
  'hamburger.music': 'Music',

  // Tutorial hint panel
  'tutorial.dismiss': 'X',
  'tutorial.skip': 'Laktawan',

  // Number formatting
  'format.millions': 'M',
  'format.thousands': 'K',

  // FTUE hints
  'ftue.brand_new': 'Mabuhay, Kumander! I-click ang Scout barko mo para piliin ito.',
  'ftue.first_select': 'Magaling! Ngayon, i-right-click ang malapit na hex para ilipat ang Scout mo.',
  'ftue.first_move': 'Gumagalaw ka na! Mag-explore ng mapa \u2014 ang madilim na hexes ay hindi pa nadidiskubre.',
  'ftue.explore_vision': 'Humanap ng asteroid at i-click ang Mine para mag-mine ng minerals.',
  'ftue.first_mine': 'Galing mag-mine! Mag-dock sa Earth para i-unload ang cargo mo.',
  'ftue.first_dock': 'Subukan mong buksan ang Ship Store para makita ang mga available na barko.',
  'ftue.understand_hud': 'Gamitin ang mga button sa itaas para bumili ng barko, mag-trade, at marami pa!',
  'ftue.first_purchase': 'Handa ka nang sakupin ang mga bituin! Tutorial complete.',

  // Welcome asteroid
  'ftue.welcome_asteroid': 'May Welcome Gift asteroid na lumitaw malapit! I-mine ito para makuha ang reward mo.',
  'asteroid.welcome_gift': 'Welcome Gift',
  'notification.welcome_claimed': 'Na-claim ang welcome reward!',

  // ── How To Guide ──────────────────────────────────────────
  'howto.title': 'PAANO LARUIN',
  'howto.skip': 'Laktawan',
  'howto.next': 'Susunod',
  'howto.back': 'Bumalik',
  'howto.done': 'Tapos Na',
  'howto.launch': 'Simulan \u25b6',
  'howto.page1_title': 'Maligayang Pagdating, Commander',
  'howto.page1_bullet1': 'Ang iyong fleet. Ang iyong teritoryo. Isang persistent na galaxy kung saan bawat aksyon ay may marka.',
  'howto.page1_bullet2': 'Gumawa ng warships, miners, at scouts. Angkinin ang iyong lugar sa mga bituin.',
  'howto.page2_title': 'Tuklasin ang Hindi Alam',
  'howto.page2_bullet1': 'Lumipat sa isang hex para mag-explore. Ang sensors ay nagpapakita ng malapit na espasyo \u2014 ang iba ay kadiliman.',
  'howto.page2_bullet2': 'Mas ligtas malapit sa Earth. Mas mayaman (at mas mapanganib) sa malayo.',
  'howto.page3_title': 'Itayo ang Iyong Imperyo',
  'howto.page3_bullet1': 'Mag-mine ng asteroids para sa resources \u2014 iron, platinum, pati dark matter.',
  'howto.page3_bullet2': 'Mag-dock sa station para mag-unload, mag-repair, at mag-upgrade ng fleet.',
  'howto.page4_title': 'Kunin ang sa Kanila',
  'howto.page4_bullet1': 'Atakihin ang mga kalaban, salvage ang mga wreck, at kunin ang loot.',
  'howto.page4_bullet2': 'Mag-raid ng enemy stations at kontrolin ang trade lanes.',
  'howto.page5_title': 'Laruin sa Gusto Mo',
  'howto.page5_bullet1': 'Sumali sa Alliance para mag-share ng research, territory, at power \u2014 o mag-solo.',
  'howto.page5_bullet2': 'Maging miner, pirate, tycoon, o fleet commander. Ikaw ang bahala.',
  'howto.page6_title': 'Naghihintay ang Hindi Alam',
  'howto.page6_bullet1': 'Tumuklas ng alien relics, Cryptoids, at Leviathans sa deep space.',
  'howto.page6_bullet2': 'Malawak ang galaxy. Paano mo ito sasakupin ay nasa iyo.',
  'nav.how_to': 'Paano',
  'dialog.how_to': 'PAANO LARUIN',

  // ── Mineral Inventory Dialog ──────────────────────────────
  'ore.browse_trade': 'Browse Trade Hub',
  'ore.total_mined': 'Kabuuang Na-mine',
  'ore.base_value': 'Base Value',
  'ore.market_data': 'MARKET DATA',
  'ore.lowest': 'Pinakamababa',
  'ore.average': 'Average',
  'ore.highest': 'Pinakamataas',
  'ore.active_listings': 'Active Listings',
  'ore.no_listings': 'Walang listings',
  'ore.sell': 'Ibenta',
  'ore.select_location': 'Pumili ng lokasyon para tingnan ang minerals',
  'ore.total_minerals': 'Kabuuang Minerals',
  'ore.mineral_types': 'Mga Uri ng Mineral',
  'ore.stored_minerals': 'STORED MINERALS',
  'ore.est_value': 'Est. Value (base)',
  'ore.in_inventory': 'Sa Inventory',
  'ore.tab_all': 'Lahat',
  'ore.tab_by_location': 'Sa Lokasyon',

  // ── Alliance HQ Dialog ────────────────────────────────────
  'alliance_hq.outpost': 'Outpost',
  'alliance_hq.station': 'Station',
  'alliance_hq.fortress': 'Fortress',
  'alliance_hq.citadel': 'Citadel',
  'alliance_hq.equal_split': 'Equal Split',
  'alliance_hq.rank_weighted': 'Rank Weighted',
  'alliance_hq.activity_weighted': 'Activity Weighted',
  'alliance_hq.custom': 'Custom',

  // ── Station Management Dialog ─────────────────────────────
  'station_mgmt.basic_desc': 'Basic supply point. Mababang storage, mababang halaga.',
  'station_mgmt.mid_desc': 'Mid-tier logistics hub. Mas malaking storage.',
  'station_mgmt.fort_desc': 'Malakas na depensa. Matibay na outpost.',
  'station_mgmt.capital_desc': 'Malaking command station. Maximum storage at presensya.',
  'station_mgmt.hp': 'HP',
  'station_mgmt.storage': 'Storage',
  'station_mgmt.owned_stations': 'MGA STATION MO',
  'station_mgmt.no_stations': 'Wala pang station',
  'station_mgmt.get_started': 'Bumili ng station sa itaas para magsimula',

  // ── Wreckage Dialog — time formatting ────────────────────
  'time.days': 'd',
  'time.hours': 'h',
  'time.minutes': 'm',
  'time.expired': 'Expired',

  // Crew tab
  'crew.loading': 'Nilo-load ang crew...',
  'crew.none_assigned': 'Walang nakatalagang crew',
  'crew.skill_combat': 'Combat',
  'crew.skill_piloting': 'Piloting',
  'crew.skill_navigation': 'Navigation',
  'crew.skill_engineering': 'Engineering',
  'crew.skill_science': 'Science',

  // ── Platforms ──────────────────────────────────────────────
  'platform.basic': 'Basic Platform',
  'platform.advanced': 'Advanced Platform',
  'platform.elite': 'Elite Platform',
  'platform.legendary': 'Legendary Platform',
  'platform.deploy': 'Mag-deploy ng Platform',
  'platform.relocate': 'Ilipat ang Platform',
  'platform.manage': 'Pamahalaan ang Platforms',
  'platform.purchase': 'Bumili ng Platform',
  'platform.mining_yield': 'Orbital Mining Yield',
  'platform.storage': 'Platform Storage',
  'platform.capabilities': 'Kakayahan',
  'platform.dock': 'Docking Bay',
  'platform.repair': 'Repair Bay',
  'platform.shipyard': 'Shipyard',
  'platform.build': 'Unit Building',
  'platform.mining': 'Orbital Mining',
  'platform.earth_station': 'Earth Orbital Station',
  'platform.public': 'Pampublikong Platform',
  'planet.resources': 'Mga Resources ng Planeta',
  'planet.depleted': 'Ubos Na',
  'planet.remaining': 'Natitira',
  'commanddock.dock_platform': 'Mag-dock sa Platform',

  // ── Leaderboard ────────────────────────────────────────────
  'nav.leaderboard': 'Leaderboard',
  'dialog.leaderboard': 'ALLIANCE LEADERBOARD',
  'leaderboard.rank': 'Rank',
  'leaderboard.alliance': 'Alliance',
  'leaderboard.prestige': 'Prestige',
  'leaderboard.territory': 'Territory',
  'leaderboard.members': 'Members',
  'leaderboard.hq_tier': 'HQ Tier',
  'leaderboard.no_data': 'Walang alliance data na available.',
  'leaderboard.refresh': 'Refresh',
};
